import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unittaskconfiguration/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    save: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unittaskconfiguration/edit/save", vo, successCallback, failureCallback);
    }
};

export default EditService;